export const SET_TOOLTIP_STEP = 'SET_TOOLTIP_STEP';
export const TOOLTIPS_SKIPPED = 'TOOLTIPS_SKIPPED';
export const SKIP_TOOLTIPS = 'SKIP_TOOLTIPS';
export const GOT_IT_CLICKED = 'GOT_IT_CLICKED';
export const SET_TOOLTIPS_DATA = 'SET_TOOLTIPS_DATA';
export const LOAD_TOOLTIPS_DATA = 'LOAD_TOOLTIPS_DATA';
export const LOAD_HELP_INTRO_DATA = 'LOAD_HELP_INTRO_DATA';
export const SET_HELP_INTRO_DATA = 'SET_HELP_INTRO_DATA';
export const CHANGE_HELP_INTRO_DATA = 'CHANGE_HELP_INTRO_DATA';
